module.exports = __webpack_public_path__ + "img/ctrl-v-stub-down--i.8ce52b76.svg";